jQuery(document).ready(function( $ ) { 
    /*
     * remove no-js class after document is ready
     */
    $('html.no-js').removeClass('no-js');

    $('.togglesearch a').on('click',function() {
        $('.ec-search-modal').modal({show:true});
    });

//     $( window ).on( 'panelsStretchRows', function(event) {
// // debugger;
//         event.preventDefault();
//         console.log('panelStrech!');
//         console.log('TEst:' + imagesCompare);
//     } );

    
    /*
     * activate tooltips and popover
     */
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    /* Scroll to Target
     */
    $('a.page-scroll,li.page-scroll>a,.page-scroll a').bind("click", jump);

    if (location.hash) {
        setTimeout(function () {
            $('html, body').scrollTop(0).show();
            jump();
        }, 0);
    } else {
        $('html, body').show();
    }

    /*
     * OWL Slider
     */
    var owl = $('.owl-carousel');
    owl.owlCarousel({
        items:1,
        loop:true,
        autoplay:true,
        autoplayTimeout:5000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        nav: false,
        dots: true,
        autoplayHoverPause:true,
        margin:0,
        autoHeight:true
    });

    function getReferenceColumns() {
        var vPortWidth = $(window).width();

        if (vPortWidth >= 992) {
            return 4;
        }

        if (vPortWidth >= 768) {
            return 3;
        }

        return 2;
    }

    function escapeReferenceText(value) {
        return $('<div>').text(value || '').html();
    }

    function buildReferenceDetails(image) {
        var imageUrl = image.data('image') || '';
        var header = image.data('header') || '';
        var description = image.data('description') || '';
        var projectNumber = image.data('projectnr') || '';
        var contactUrl = '/kontakt/?project=' + encodeURIComponent(projectNumber + ' ' + imageUrl) + '#anfrage';

        return '<div style="display: none;" class="ref-wrapper">'
        +            '<div class="container">'
        +                '<div class="row d-flex align-items-center">'
        +                    '<div class="col-lg-6">'
        +                        '<img class="img-fluid" src="' + escapeReferenceText(imageUrl) + '" alt="' + escapeReferenceText(header) + '" title="' + escapeReferenceText(header) + '">'
        +                    '</div>'
        +                    '<div class="col-lg-6">'
        +                        '<h3>' + escapeReferenceText(header) + '</h3>'
        +                        '<p>'
        +                            escapeReferenceText(description)
        +                        '</p>'
        +                        '<p class="small">'
        +                            'Projektnummer: ' + escapeReferenceText(projectNumber)
        +                        '</p>'
        +                        '<p>'
        +                            '<a href="' + contactUrl + '" class="btn btn-primary"><i class="fas fa-envelope"></i> Unverbindlich anfragen</a>'
        +                        '</p>'
        +                        '<p>'
        +                            '<a href="' + escapeReferenceText(imageUrl) + '" target="_blank" download><i class="fas fa-download"></i> Bild downloaden</a>'
        +                        '</p>'
        +                    '</div>'
        +                '</div>'
        +            '</div>'
        +        '</div>';
    }

    $('.references').each(function() {
        var gallery = $(this);
        var limit = parseInt(gallery.data('reference-limit'), 10) || 12;
        var hiddenReferences = gallery.find('.ref-image.d-none');

        if (!hiddenReferences.length) {
            gallery.find('.js-load-more-references').addClass('d-none');
        }

        gallery.on('click', '.js-load-more-references', function() {
            var button = $(this);
            var nextReferences = gallery.find('.ref-image.d-none').slice(0, limit);

            gallery.find('.ref-wrapper').slideUp(400, function() {
                $(this).remove();
            });
            gallery.find('.ref-image.active, .ref-image img.active').removeClass('active');

            nextReferences.hide().removeClass('d-none').slideDown(300);

            if (!gallery.find('.ref-image.d-none').length) {
                button.addClass('d-none');
            }
        });

        gallery.on('click', '.ref-image>div>img', function() {
            var image = $(this);
            var imageWrapper = image.closest('.ref-image');
            var visibleReferences = gallery.find('.ref-image').not('.d-none');
            var imageIndex = visibleReferences.index(imageWrapper);
            var rowEndIndex = Math.min(
                Math.ceil((imageIndex + 1) / getReferenceColumns()) * getReferenceColumns() - 1,
                visibleReferences.length - 1
            );
            var details = buildReferenceDetails(image);
            var currentDetails = gallery.find('.ref-wrapper');

            if (image.hasClass('active')) {
                return;
            }

            gallery.find('.ref-image.active, .ref-image img.active').removeClass('active');
            image.addClass('active');
            imageWrapper.addClass('active');

            if (currentDetails.length) {
                currentDetails.slideUp(400, function() {
                    $(this).remove();
                    visibleReferences.eq(rowEndIndex).after(details);
                    gallery.find('.ref-wrapper').slideDown(400);
                });
            } else {
                visibleReferences.eq(rowEndIndex).after(details);
                gallery.find('.ref-wrapper').slideDown(400);
            }
        });
    });
});

/* ecreation. Scroll to Target
 */
var jump = function (e)
{
    var $topoffset = 0;
    var vport = jQuery(window);

    // if ( vport.width() < 768 ) { 
    //     $topoffset = 60;
    // } else {
    //     $topoffset = 168;
    // }

    if (e) {
        //e.preventDefault();
        var target = jQuery(this).attr("href");
        target = target.substr(target.indexOf('#'));
    } else {
        var target = location.hash;
    }

    jQuery('html,body').animate(
            {
                scrollTop: jQuery(target).offset().top - $topoffset
            }, 1500, function ()
    {
        location.hash = target;
    });

}
